import { render, staticRenderFns } from "./Shimmer.vue?vue&type=template&id=cb258526&"
import script from "./Shimmer.vue?vue&type=script&lang=js&"
export * from "./Shimmer.vue?vue&type=script&lang=js&"
import style0 from "./Shimmer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports